module.exports = __webpack_public_path__ + "img/mamey-sapote-350x184.7c63e33f.jpg";